/**
 * 基础常量配置
 *
 */

/**
 * 抬头类型
 * 企业，个人或政府机构
 */
export var invoiceTitleType = {
  /**企业 */
  company: 2,
  /**个人、政府机构 */
  person: 1,
  /**非企业性单位 */
  nonbusiness: 3
};

/**
 * 发票种类
 * 普通发票、电子普通发票、专用发票
 */
export var invoiceType = {
  /**普通发票 */
  puTong: 1,
  /**电子普通发票 */
  dianZiPuTong: 2,
  /**专用发票 */
  zhuanYong: 3
};

/**路由名称 */
export var routerNames = {
  //首页
  HomeIndex: 'HomeIndex',
  //登录页面
  login: 'login',
  //发票状态
  state: 'state',
  //发票抬头 首页、列表、模糊检索
  InvoiceTitleIndex: 'InvoiceTitleIndex',
  //发票抬头 新增
  InvoiceTitleCreate: 'InvoiceTitleCreate',
  //发票抬头 编辑
  InvoiceTitleUpdate: 'InvoiceTitleUpdate',
  //发票抬头 详情
  InvoiceTitleDetail: 'InvoiceTitleDetail',

  //发票分享到邮箱
  InvoiceShare2Email: 'InvoiceShare2Email',

  //订单开票 确认页面
  OrderInvoiceIssue: 'OrderInvoiceIssue',

  //发票列表页面
  OrderInvoices: 'OrderInvoices',
  //发票详情页
  OrderInvoicesOwtDetail: 'OrderInvoicesOwtDetail',
  //集成发票详情页
  OrderInvoicesImage: 'OrderInvoicesImage',


  //扫码开票
  Redirect: 'Redirect',
  Error404: '404'

};



// WEBPACK FOOTER //
// ./src/common/js/const.js